import 'babel-polyfill';
import Vue from 'vue';
import VueSocialSharing from 'vue-social-sharing';
import firebase from 'firebase/app';
import App from './App.vue';
import router from './router';
import vuetify from './plugins/vuetify';

Vue.config.productionTip = false;

Vue.prototype.$contact = process.env.VUE_APP_CONTACT_EMAIL;

// ENABLE DOWNLOAD LINK
Vue.prototype.$download = process.env.VUE_APP_DOWNLOAD === 'true';
Vue.prototype.$googleplay = process.env.VUE_APP_GOOGLE_PLAY;
Vue.prototype.$appstore = process.env.VUE_APP_APPLE_STORE;
// Vue.prototype.$facebook = 'https://facebook.com/';

// DOCTOR LINK
Vue.prototype.$doctor = process.env.VUE_APP_DOCTOR === 'true';
Vue.prototype.$doctorlink = process.env.VUE_APP_DOCTOR_LINK;
// ENABLE DOCTOR REG
if (process.env.VUE_APP_DOCTOR === 'true') {
  Vue.prototype.$doctorsignup = `${process.env.VUE_APP_DOCTOR_LINK}`;
} else {
  Vue.prototype.$doctorsignup = '#';
}

// ENABLE TERMS AND PRIVACY LINK
Vue.prototype.$launch = process.env.VUE_APP_LAUNCH === 'true';


Vue.prototype.$recipient = 'For Healthcare Customers';
Vue.prototype.$providers = 'For Healthcare Providers';

// Social Mediia Sharing
Vue.use(VueSocialSharing);

// Firebase
const firebaseConfig = {
  apiKey: 'AIzaSyCas2SlGWGxzX6lfYXAq4vmobNyaTUjy4s',
  authDomain: 'healthnow-281106.firebaseapp.com',
  databaseURL: 'https://healthnow-281106.firebaseio.com',
  projectId: 'healthnow-281106',
  storageBucket: 'healthnow-281106.appspot.com',
  messagingSenderId: '494392866210',
  appId: '1:494392866210:web:65bf6fe110062166986efb',
  measurementId: 'G-CRLFJF11XM',
};

// Initialize Firebase
firebase.initializeApp(firebaseConfig);

new Vue({
  router,
  vuetify,
  render: (h) => h(App),
}).$mount('#app');
